import { types } from 'mobx-state-tree';
import { NameModel, PhoneModel } from '../../base';
import { AppealRequesterTypes } from '../../../constants';
import { OtherProviderModel } from '../../others';

export const RequesterModel = NameModel.props({
  _id: types.optional(types.identifier, ''),
  email: types.optional(types.maybeNull(types.string), null),
  phone_numbers: types.optional(types.array(PhoneModel), []),
  _type: types.optional(types.enumeration(AppealRequesterTypes), 'tenant'),

  // Есть только если type === 'tenant'
  number: types.optional(types.maybeNull(types.string), ''),

  // Есть только если type === 'employee' или 'other_employee'
  department_name: types.optional(types.maybeNull(types.string), null),
  position_name: types.optional(types.maybeNull(types.string), null),
  provider: types.optional(types.maybeNull(OtherProviderModel), null),
}).views((self) => ({
  get role() {
    return {
      tenant: self._type === 'tenant',
      employee: self._type === 'employee',
      otherPerson: self._type === 'other_person',
      otherEmployee: self._type === 'other_employee',
      ourSPBPortal: self._type === 'our_spb_portal',
    };
  },
}));
